import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'

import ChangelogPopup from './Popup.vue'
import ChangelogBadge from '@/app/components/changelog/Badge.vue'
import { ChangelogView } from '@/models/changelog'
import { assertNotNull } from '@/helpers/typing'
import type { HeaderView } from '@/models/header'
import * as Mixpanel from '@/analytics/mixpanel/mixpanel'

export default /*@__PURE__*/_defineComponent({
  __name: 'PopupButton',
  props: {
    view: {},
    headerView: {}
  },
  setup(__props: any) {

const props = __props

const popupChangelog = ref<InstanceType<typeof ChangelogPopup> | null>(null)

async function toggleChangelogDialog(): Promise<void> {
  await props.view.loadData()
  props.headerView.toggle()
  assertNotNull(popupChangelog.value).show()
  Mixpanel.trackChangelogButtonClick()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "changelog-button",
      onClick: toggleChangelogDialog
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "changelog-button__label" }, [
        _createElementVNode("svg", {
          width: "14",
          height: "20",
          viewBox: "0 0 14 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("path", {
            d: "M7.80028 1L1 12H7L6.19972 19L13 8H7L7.80028 1Z",
            stroke: "inherit",
            "stroke-width": "0.9",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ]),
        _createTextVNode(" What's new ")
      ], -1)),
      _createVNode(ChangelogBadge, {
        class: "changelog-button__badge",
        view: __props.view
      }, null, 8, ["view"])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#appRoot" }, [
      _createVNode(ChangelogPopup, {
        ref_key: "popupChangelog",
        ref: popupChangelog,
        view: __props.view
      }, null, 8, ["view"])
    ]))
  ]))
}
}

})